















import { Component,Vue } from 'vue-property-decorator'
import { State,Getter,namespace,Action } from 'vuex-class'
const site = namespace('site')
const user = namespace('user')

//
interface User {
    name: string, //用户名
    mobile: string, // 用户手机号
    password: string, // 用户密码
    role: string, // 角色： manager店长,courier快递员,clerk店员
    sub_sys: string, //属于哪个子系统
    site: string, //选择网点列表
    remarks: string // 备注
}
@Component
export default class AddUser extends Vue{
    loading:boolean = false
    form:User = {
        name: '',
        mobile: '',
        password: '',
        role: '',
        sub_sys: '',
        site: '',
        remarks: ''
    }
    get formOptions(){
        return [{
            label: '用户名',
            prop: 'name',
            type: 'input',
            ruleType: 'text'
        },{
            label: '手机号',
            prop: 'mobile',
            type: 'input',
            ruleType: 'text'
        },{
            label: '密码',
            prop: 'password',
            type: 'input',
            ruleType: 'text'
        },{
            label: '角色',
            prop: 'role',
            type: 'select',
            options:this.clientRole,
            optionsLabel: 'name',
            optionsValue: 'code',
            ruleType: 'text'
        },{
            label: '所属系统',
            prop: 'sub_sys',
            type: 'select',
            options:this.subSys,
            optionsLabel: 'name',
            optionsValue: '_id',
            ruleType: 'text'
        },{
            label: '选择网点',
            prop: 'site',
            type: 'slot',
            options: this.siteList,
            optionsLabel: 'name',
            optionsValue: '_id',
            ruleType: 'text'
        },{
            label: '备注',
            prop: 'remarks',
            type: 'textarea',
            row: 2
        }]
    }
    @Getter('clientRole') clientRole:any
    @Getter('subSys') subSys:any
    @site.State('list') siteList:any
    @site.Action('getSiteList') getSiteList:any
    @user.Action('addClientUser') addClientUser:any

    async mounted(){
        await this.getSiteList();
    }
    // 查询网点
    async remoteMethod(query:string) {
        if (query !== '') {
            this.loading = true;
            await this.getSiteList({
                name: query
            });
            this.loading = false;
        }
    }
    async add(){
        const status = await this.$refs.builder.submitForm();
        if(status){
            const res = await this.addClientUser(this.form);
            if(res){
                if(res) this.$message({message: '添加成功', type: 'success'});
                this.resetForm()
            }
        }
    }
    // 重置表单
    resetForm(){
        this.$refs.builder.resetForm()
    }
    
}
